import { Button } from "@/components/ui/button"
import { ArrowLeft } from "lucide-react"
import { useNavigate } from "react-router-dom"

/**
 * Botão para voltar do contexto admin para o sistema principal
 */
export function BackToSystemButton() {
  const navigate = useNavigate()

  const handleBackToSystem = () => {
    navigate("/dashboard")
  }

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={handleBackToSystem}
      className="text-muted-foreground hover:text-foreground"
    >
      <ArrowLeft className="mr-2 h-4 w-4" />
      Voltar para o Sistema
    </Button>
  )
}
